var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu bg-base-100 w-56 rounded-box"},[_c('li',[_c('a',[_vm._v("Item 1")])]),_c('li',[_c('a',[_vm._v("Item 2")])]),_c('li',[_c('a',[_vm._v("Item 3")])])])
}]

export { render, staticRenderFns }